var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zoom-on-hover",class:{ zoomed: _vm.zoomed },on:{"touchstart":_vm.touchzoom,"mousemove":_vm.move,"mouseenter":_vm.zoom,"mouseleave":_vm.unzoom}},[_c('img',{ref:"normal",staticClass:"normal",attrs:{"src":_vm.imgNormal}}),_c('img',{ref:"zoom",staticClass:"zoom",attrs:{"src":_vm.imgZoom || _vm.imgNormal}})])
}
var staticRenderFns = []

export { render, staticRenderFns }